export default {
  name: 'DisplayedTimeFormat',
  props: {
    nowrap: {
      default: false,
      type: Boolean,
    },
    period: {
      required: true,
      type: Object,
    },
    showWeekday: {
      default: false,
      type: Boolean,
    },
    textColorClass: {
      default: 'text-black',
      type: String,
    },
    textSizeClass: {
      default: 'sm:text-lg text-xl',
      type: String,
    },
    textWeightClass: {
      default: '',
      type: String,
    },
  },
  computed: {
    showEndPeriod() {
      return this.period?.end_date || this.period?.end_time;
    },
  },
  methods: {
    showEndDate(start, end) {
      return start !== end;
    },
  },
};
